<template>
  <div class="invest">
    <div class="invest-title">
      <van-icon
        @click="goableBack()"
        class="invest-arrow-left"
        name="arrow-left"
      />
      <span>投资以下产品可获积分奖励</span>
    </div>
    <tian-products-regular></tian-products-regular>
  </div>
</template>

<script>
import { Tab, Tabs, Icon } from 'vant'

import TianProductsRegular from './components/products-regular'
import { mapMutations, mapGetters } from 'vuex'

export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Icon.name]: Icon,
    TianProductsRegular,
  },

  data() {
    return {
      activeName: '定期产品',
    }
  },

  beforeMount() {},
  computed: {
    ...mapGetters(['userInfo', 'channel']),
  },

  methods: {},
}
</script>

<style scoped lang="less">
@import url('./idx.less');
.invest {
  min-height: 100vh;
  background-color: #f1f5f8;
  .vip-regular {
    text-align: center;
    margin-top: 70px;
  }
}
</style>
